import { Component, ViewChild, ElementRef, Input } from '@angular/core';
import { ViewController, NavParams, Events } from 'ionic-angular';

// Providers 
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { HelperService } from '../../providers/helpers/helper-service';

@Component({
  templateUrl: 'course.modal.html'
})

export class CourseModalPage
{
  edit: boolean = false;
  modalTitle: string = 'New Course';
  course: any = {};
  instructor: any = {};
  dateRange: any = {};

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public instructorsService: InstructorsService,
    public helperService: HelperService,
    public events: Events
  ) {
    this.dateRange = this.helperService.getYearRange();
    let instructors = this.navParams.get('instructors');
    this.instructor = instructors[0];
    if ( this.navParams.get('edit') === true )
    {
      this.edit = true;
      this.modalTitle = 'Edit Course';
      this.course = this.navParams.get('editData');
    }
  }

  saveCourse()
  {
    this.course.instructor_id = this.instructor.instructor_id;
    this.instructorsService.saveCourse( this.course )
      .subscribe( data => {
        if ( this.edit === false )
        {
          this.instructor.courses.push( data );
        }
        this.events.publish('app:log', {
          message: 'Instructor refresher course entry saved.',
          status: 'success',
          type: 'save instructor course'
        });
    },
    error => {
      this.helperService.showErrors( error );
    });
    this.dismissModal();
  }

  dismissModal() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/course.modal.ts